import { ReactNode, useContext } from 'react'
import { navigate } from 'gatsby-plugin-intl'

import Link from '@atoms/Link'
import { getUserDetail, getUserQuick, signOut } from '@models/User'
import { StoreContext } from '@models/Store'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type MypageWrapperProps = {
  type: 'save' | 'history' | 'setting'
  children: ReactNode
}
const MypageWrapper = ({ type, children }: MypageWrapperProps) => {
  const { entity, action } = useContext(StoreContext)
  const { t } = useTranslation()

  const onSignOut = async () => {
    if (entity.user === undefined) {
      return
    }

    navigate('/')
    action.reload()
    action.setUser({
      ...entity.user,
      isSignIn: false,
    })
    action.updateBookmark([])

    await signOut()
    const user = await getUserQuick()
    action.setUser(user)
    getUserDetail(user).then(action.setUser)
    action.setUser(user)
  }

  return (
    <div className={style.wrapper}>
      <div className={style.title} data-show={entity.user?.isSignIn}>
        {t('mypage.mypage')}
      </div>
      <div className={style.links}>
        <Link to="/save" data-active={type === 'save'}>
          {t('mypage.save')}
        </Link>
        <Link to="/history" data-active={type === 'history'}>
          {t('mypage.history')}
        </Link>
        {entity.user?.isSignIn && (
          <>
            <Link to="/setting" data-active={type === 'setting'}>
              {t('mypage.setting')}
            </Link>
            <button onClick={onSignOut}>{t('mypage.logout')}</button>
          </>
        )}
      </div>
      <div className={style.contents}>{children}</div>
    </div>
  )
}

export default MypageWrapper
